import { constants } from '@eti/utils';
import type { ChatExtraInfo } from './useChat';

declare const zE: any;

export const ZENDESK_SCRIPT_ID = 'ze-snippet';
export const ZENDESK_SNIPPET_URL = 'https://static.zdassets.com/ekr/snippet.js';

export const isZendeskLoaded = () =>
  Boolean(document.getElementById(ZENDESK_SCRIPT_ID) && typeof zE !== 'undefined');

const createZendeskScript = (deploymentKey: string): HTMLScriptElement => {
  const script = document.createElement('script');
  script.id = ZENDESK_SCRIPT_ID;
  script.async = true;
  script.src = `${ZENDESK_SNIPPET_URL}?key=${deploymentKey}`;
  return script;
};

export const applyZendeskIdentity = (extraInfo: ChatExtraInfo) => {
  if (isZendeskLoaded()) {
    zE('messenger:set', 'conversationFields', extraInfo);
  }
};

export const initZendesk = (
  siteLanguageCode: string,
  extraInfo: ChatExtraInfo,
  deploymentKey?: string,
) => {
  if (isZendeskLoaded() || !deploymentKey) {
    return;
  }

  const script = createZendeskScript(deploymentKey);
  script.addEventListener('load', () => {
    zE('messenger:set', 'locale', siteLanguageCode);
    zE('messenger', 'hide');
    zE('messenger:set', 'conversationFields', extraInfo);
  });

  document.head.appendChild(script);
};

export const openZendeskChat = (extraInfo?: ChatExtraInfo) => {
  if (!isZendeskLoaded()) {
    return;
  }

  const launcher = document.getElementById('launcher');
  launcher?.classList.add(...constants.MOUSE_FLOW_CLASS_NAMES.split(' '));

  zE('messenger:set', 'conversationFields', extraInfo, () => {
    zE('messenger', 'show');
    zE('messenger', 'open');
  });
};

export const closeZendeskChat = () => {
  if (isZendeskLoaded()) {
    zE('messenger', 'logoutUser');
    zE('messenger', 'close');
    zE('messenger', 'hide');
  }
};
